import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { withDevtools } from '@pinnakl/shared/signal-store';

const STORAGE_KEY = 'poemsMenuExpanded';

function readStoredMenuOpen(): boolean | null {
  const raw = localStorage.getItem(STORAGE_KEY);
  return raw === null ? null : raw === '1';
}

export const PoemsSidebarStore = signalStore(
  { providedIn: 'root', protectedState: false },
  withDevtools('poemsSidebar'),
  withState({
    menuOpen: readStoredMenuOpen() ?? true,
  }),
  withMethods(store => ({
    toggleMenu(): void {
      const next = !store.menuOpen();
      patchState(store, { menuOpen: next });
      localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
    },
    collapseIfNotPinned(): void {
      if (readStoredMenuOpen() !== true) {
        patchState(store, { menuOpen: false });
      }
    },
    setMenuOpenOnNavigation(isDashboard: boolean): void {
      if (readStoredMenuOpen() !== null) return;
      patchState(store, { menuOpen: isDashboard });
    },
  })),
);
